module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer sui-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "has-text-centered"
  }, [_c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('strong', [_vm._v("social-ui")])]), _vm._v("\n        by\n        "), _c('a', {
    attrs: {
      "href": "https://aaron-tay.github.io",
      "target": "_blank"
    }
  }, [_vm._v("aaron-tay")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Developed using\n        "), _c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("vuejs")]), _vm._v(",\n        "), _c('a', {
    attrs: {
      "href": "http://bulma.io",
      "target": "_blank"
    }
  }, [_vm._v("bulma.io")]), _vm._v(",\n        "), _c('a', {
    attrs: {
      "href": "http://placehod.it",
      "target": "_blank"
    }
  }, [_vm._v("placehold.it")]), _vm._v(",\n        "), _c('a', {
    attrs: {
      "href": "http://chancejs.com",
      "target": "_blank"
    }
  }, [_vm._v("chance")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        View it on\n        "), _c('a', {
    attrs: {
      "href": "https://github.com/aaron-tay/social.ui",
      "target": "_blank"
    }
  }, [_vm._v("GitHub")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f69daf20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 297
// module chunks = 1